import { useState } from 'react'
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism-async-light'
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism'
import json from 'react-syntax-highlighter/dist/esm/languages/prism/json'
SyntaxHighlighter.registerLanguage('json', json)
import { Copy, Check } from 'lucide-react'
import { RESPONSES } from '@/lib/responses'

type CodeProps = {
  lang?: string
  noRound?: boolean
  id?: string
  children?: string
}

const Code: React.FC<CodeProps> = ({ lang = 'json', children, noRound=false, id }) => {
  const [copied, setCopied] = useState(false)
  const code = id ? RESPONSES[id] : (children ?? '')

  const handleCopy = async () => {
    window.track('code_copied')
    await navigator.clipboard.writeText(code)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <div style={{ display: 'grid', position: 'relative' }}>
      <button
        onClick={handleCopy}
        className="
          absolute bottom-2 right-2 z-1 cursor-pointer
          rounded-md bg-neutral-800/80 p-2
          text-neutral-300 hover:text-white
          hover:bg-neutral-700
          backdrop-blur
        "
        aria-label="Copy to clipboard"
      >
        {copied ? <Check size={16} /> : <Copy size={16} />}
      </button>

      <div style={{ overflowX: 'auto' }}>
        <SyntaxHighlighter
          language={lang}
          style={vscDarkPlus}
          customStyle={noRound ? {
            borderBottomRightRadius: '0.5rem',
            borderBottomLeftRadius: '0.5rem',
            padding: '1rem',
            margin: 0,
          }: {
            borderRadius: '0.5rem',
            padding: '1rem',
            margin: 0,
          }}
        >
          {code}
        </SyntaxHighlighter>
      </div>
    </div>
  )
}

export default Code

